import type { JSX, ReactNode } from 'react';

interface ToolbarProps {
  readonly children: ReactNode;
  /**
   * Match the wider measure of a two-column screen. The bar and the content
   * below it must start on the same vertical line: a logo indented further
   * than the heading under it reads as a rendering mistake.
   */
  readonly wide?: boolean;
}

/**
 * A floating translucent layer that content scrolls *under*, not an opaque
 * strip that eats a slice of the viewport. Where the two meet there is a soft
 * scroll edge instead of a 1px rule (§materials).
 */
export function Toolbar({ children, wide = false }: ToolbarProps): JSX.Element {
  return (
    <div className="sticky top-0 z-30">
      <header className="material-bar">
        {/* the same measure the content column uses, so the two edges line up */}
        <div
          className={[
            'mx-auto flex w-full items-center justify-between gap-4 px-4 py-3',
            wide ? 'max-w-3xl lg:max-w-5xl' : 'max-w-3xl',
          ].join(' ')}
        >
          {children}
        </div>
      </header>
      <div
        aria-hidden="true"
        className="scroll-edge pointer-events-none absolute inset-x-0 top-full h-6"
      />
    </div>
  );
}
